import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

import { SystemAssetCaptureComponent } from './system-asset-capture.component';

import {
  SystemAssetCaptureCreateOrUpdateComponent
} from './system-asset-capture-create-or-update/system-asset-capture-create-or-update.component';

import {
  SystemAssetCaptureFileCreateOrUpdateComponent
} from './system-asset-capture-file-create-or-update/system-asset-capture-file-create-or-update.component';

import {
  SystemAssetManualCreateOrUpdateComponent
} from './system-asset-manual-create-or-update/system-asset-manual-create-or-update.component';

import { SystemAssetCaptureRouter } from './system-asset-capture.router';
import { SystemAssetsViewComponent } from './system-assets-view/system-assets-view.component';
import { SystemAssetsCaptureForFileAssetSourceComponent } from './system-assets-capture-for-file-asset-source/system-assets-capture-for-file-asset-source.component';
import { SystemAssetsCaptureForAssetSourceComponent } from './system-assets-capture-for-asset-source/system-assets-capture-for-asset-source.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    SystemAssetCaptureComponent,
    SystemAssetCaptureCreateOrUpdateComponent,
    SystemAssetCaptureFileCreateOrUpdateComponent,
    SystemAssetManualCreateOrUpdateComponent,
    SystemAssetsViewComponent,
    SystemAssetsCaptureForFileAssetSourceComponent,
    SystemAssetsCaptureForAssetSourceComponent
  ],

  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    MatDialogModule,
    MatProgressSpinnerModule,
    MatIconModule,
    SharedModule,
    SystemAssetCaptureRouter
  ]
})
export class SystemAssetCaptureModule {}